import type { FaireProductEntity } from "../../entity_types/product";

export const p_6bn79ed9mb: FaireProductEntity = {
  token: "p_6bn79ed9mb",
  type: "product",
  name: "Gluten Free Snack|Variety Pack Pops-All 7 Flavors | Makhana",
  brandToken: "b_2ppngtaknh",
  brandName: "Karma Wellness Kitchen",
  imageUrl:
    "https://cdn.faire.com/fastly/5e024e68f16e28ec4bc8d6f0b4a13f3ad6dff93a312b8cb5458695682b0579b7.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0a44d9f3f8e26f8b61d0947501cc59aee2212605a66d53786bb1477997bc5669.png",
    "https://cdn.faire.com/fastly/aa8eff199df6e82120ec23eb86594379cca62ef8ce4ddd3a2dd215ba3a7d7b65.png",
    "https://cdn.faire.com/fastly/83319ae74c0a44a0c86ddca37a2bb87a3a6ff0e174690ff07fefd6d34bd4f9aa.png",
    "https://cdn.faire.com/fastly/caba1dc7317d81039422846186164658c01f9dd1eb7f0302e01e6bb995711c81.png",
    "https://cdn.faire.com/fastly/0a1a89244c0bf1c3ba2570072d57a80086e8edfdc8497fa5111a69845ab39d72.png",
    "https://cdn.faire.com/fastly/530982a661c6607e68d2c76f86866b49c3c3832e4ce0bb4f3ed4ac0bb5096f72.png",
    "https://cdn.faire.com/fastly/2ed27f22adcba968c301ac79a56ba0181b7bef0cac6402b44253279956568629.png",
    "https://cdn.faire.com/fastly/1b6a1093bb81e4b70e92b616540661fb4994aa6a40626932a796b55dbc6a2f56.png",
  ],
  priceDollars: 4.43,
  description:
    "Popped Water Lily Seeds are protein rich, super food snack.\n\n3 gm protein, 3 gm fiber, Gluten Free alternative to Popcorn or Chips.&nbsp;\n\nOur variety pack contains all of our delicious flavors - Classic Sea Salt, Spicy Masala, Apple Cider Vinegar, White Cheddar, Turmeric, Chocolate and Vegan Cheese\n\nWe have multiple variations for you to choose from.&nbsp;\n\n1 oz bags.&nbsp;\n",
  tags: [],
  msrpDollars: 6.93,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:55:23.714Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
